import { render } from "./redbag.vue?vue&type=template&id=b588439e&scoped=true"
import script from "./redbag.vue?vue&type=script&lang=js"
export * from "./redbag.vue?vue&type=script&lang=js"

import "@/static/redbag/redbag.css?vue&type=style&index=0&id=b588439e&scoped=true&lang=css&external"
import "./redbag.vue?vue&type=style&index=1&id=b588439e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b588439e"]])

export default __exports__